import { render, staticRenderFns } from "./CustomerAddressRow.vue?vue&type=template&id=0381aa20"
import script from "./CustomerAddressRow.vue?vue&type=script&lang=ts"
export * from "./CustomerAddressRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports